import "../legacy/legacyPatientLoginSignup.scss";

import "../legacy/legacyPatientLoginSignup.ts";
